import SiteFooter from "../components/SiteFooter";
import PublicPageHeader from "../components/PublicPageHeader";

const AboutPage = () => {
  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--secondary)" }}>
      <PublicPageHeader />
      <main className="px-6 py-12">
        <div className="max-w-4xl mx-auto bg-white rounded-2xl border p-8 md:p-10" style={{ borderColor: "var(--border)" }}>
          <h1 className="text-4xl font-bold mb-6" style={{ fontFamily: "Fraunces, serif", color: "var(--primary)" }}>
            About Us
          </h1>

          <div className="space-y-5 text-[15px] leading-7 opacity-90">
            <p>
              MoolTax is an income tax return filing platform in India 
              designed to help individuals and businesses file their ITR easily 
              with guided support and expert assistance.
            </p>
            <p>
              We support salaried individuals with Form 16 based filing, 
              tax regime selection (old vs new), and complete assistance in 
              preparing and filing income tax returns in India.
            </p>
            <p>
              We help users organize their tax information, upload relevant documents securely,
              track filing progress, and communicate with tax professionals when needed.
            </p>
            <div>
              <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Our Mission
              </h2>
              <p>To make tax filing simple, guided, and trustworthy for everyone.</p>
            </div>
            <div>
              <h2 className="text-xl font-semibold mb-2" style={{ fontFamily: "Fraunces, serif" }}>
                Why Choose MoolTax
              </h2>
              <ul className="list-disc pl-6 space-y-1">
                <li>Guided filing workflow</li>
                <li>Secure document upload</li>
                <li>Transparent status tracking</li>
                <li>Direct support communication</li>
                <li>Simple and user-friendly experience</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default AboutPage;